/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appGithub_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly githubEnabled: boolean | null;
        readonly githubInstallationId: number | null;
        readonly githubUnauthorizedInstallation: number | null;
    } | null;
    readonly " $refType": "appGithub_viewer";
};
export type appGithub_viewer$data = appGithub_viewer;
export type appGithub_viewer$key = {
    readonly " $data"?: appGithub_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appGithub_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appGithub_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubInstallationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "githubUnauthorizedInstallation",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '4b60a984904ac7c82293338561bf2837';
export default node;
